import ReusableDataTable from "src/components/table/ReusableDataTable";
import { mapCustomerToDataTable as mapData } from "./Helper";
import GetCustomerColumns from "./ColumnDefinition/CustomerColumn/GetCustomerColumns";

const CustomerTable = ({
  data,
  handleSyncData,
  handleChangeStatus,
  handlePopupShowDevice,
  status,
}) => {
  const columns = GetCustomerColumns({
    handleSyncData,
    handleChangeStatus,
    handlePopupShowDevice,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default CustomerTable;
